const isProduct = true;
const buff = isProduct ? 'pro' : 'dev';

const basicUrl = !isProduct ? 'http://localhost:8889' : 'https://csapi.lerisktech.com';

const api = {

    // 登录接口 成功返回token 和用户信息
    login: `${basicUrl}/agent/login`,

    //验证码
    getVerify:   `${basicUrl}/user/getVerify`,
    checkVerify: `${basicUrl}/user/checkVerify`,


    //获取所有代理商 添加账号 停用 授权角色
    getAllAuthAgent:     `${basicUrl}/agent/getAllAuthAgent`,
    getAllAuthAgentPage: `${basicUrl}/agent/getAllAuthAgentPage`,
    saveAuthAgent:       `${basicUrl}/agent/saveAuthAgent`,
    stopAuthAgent:       `${basicUrl}/agent/stopAuthAgent`,
    giveRole:            `${basicUrl}/agent/giveRole`,
    modifyAuthAgent:     `${basicUrl}/agent/modifyAuthAgent`,

    //查询所有角色  修改角色  删除角色
    getAllAuthRole:         `${basicUrl}/agent/getAllAuthRole`,
    getAllAuthRoleTrue:     `${basicUrl}/agent/getAllAuthRoleTrue`,
    modifyAuthRole:         `${basicUrl}/agent/modifyAuthRole`,
    removeAuthRole:           `${basicUrl}/agent/stopAuthRole`,
    getAllAuthAgentByRoleId:  `${basicUrl}/agent/getAllAuthAgentByRoleId`,
    modifyPassword:           `${basicUrl}/agent/modifyPassword`,

    //查询微信 支付宝用户信息
    getAllUserInfo:      `${basicUrl}/user/getAllUserInfo`,

    //查询所有菜单
    getAllAuthMenu:      `${basicUrl}/agent/getAllMenu`,
    getMenuByParentId:   `${basicUrl}/agent/getMenuByParentId`,
    saveAuthMenu:        `${basicUrl}/agent/saveAuthMenu`,
    deleteAuthMenu:      `${basicUrl}/agent/deleteAuthMenu`,
    getMenuByRoleId:     `${basicUrl}/agent/getMenuByRoleId`,

    //设备查询 修改计费  商户绑定
    getAllEquipment:     `${basicUrl}/equipment/getAllEquipment`,
    getAllMerchant:      `${basicUrl}/equipment/getAllMerchant`,
    modifyEquipment:     `${basicUrl}/equipment/modifyEquipment`,
    modifyEquipmentDeposit:`${basicUrl}/equipment/modifyEquipmentDeposit`,
    bindMerchant:        `${basicUrl}/equipment/bindMerchant`,
    bindTime:            `${basicUrl}/equipment/bindTime`,
    popupEquipmentOnly:  `${basicUrl}/equipment/popupEquipmentOnly`,
    popupEquipmentAll:     `${basicUrl}/equipment/popupEquipmentAll`,
    accountingEquipment:   `${basicUrl}/equipment/accountingEquipment`,

    popupEquipmentOnlyF:  `https://api.lerisktech.com/nb/openEquipmentByIndex`,



    //会员卡查询
    getMemberCard:        `${basicUrl}/user/getMemberCard`,
    modifyCard:           `${basicUrl}/user/modifyCard`,
    getMemberCardRecord:  `${basicUrl}/user/getAllMemberCardRecord`,

    //订单查询 查询今天订单 结束订单 订单统计
    getOrders:            `${basicUrl}/order/getOrders`,
    getTodayOrders:       `${basicUrl}/order/getTodayOrders`,
    stopOrder:            `${basicUrl}/order/stopOrder`,
    accountingOrder:      `${basicUrl}/order/accountingOrder`,
    getWeekOrders:        `${basicUrl}/order/getWeekOrders`,
    getMonthOrders:       `${basicUrl}/order/getMonthOrders`,
    getTopDeviceOrders:   `${basicUrl}/order/getTopDeviceOrders`,
    getOrderChannelStats: `${basicUrl}/order/getOrderChannelStats`,
    getBottomDeviceOrders:`${basicUrl}/order/getBottomDeviceOrders`,
    getOrderPriceStats:   `${basicUrl}/order/getOrderPriceStats`,

    getOrdersCustomer:     `${basicUrl}/order/getOrdersCustomer`,
    getOrdersCustomerHide: `${basicUrl}/order/getOrdersCustomerHide`,  // 漏
    setCustomerOrder:      `${basicUrl}/order/setCustomerOrder`,

    //预授权订单管理
    freezeSearch:          `${basicUrl}/freeze/search`,
    unFreeze:              `${basicUrl}/freeze/unFreeze`,
    tradePay:              `${basicUrl}/freeze/tradePay`,

    freezeSearchWx:        `${basicUrl}/freeze/wx/search`,
    tradePayWx:            `${basicUrl}/freeze/wx/completePayScoreOrder`,

}

export {
    isProduct,
    buff,
    api
}



// WEBPACK FOOTER //
// ./src/api/api.js